<!-- 货转任务单 -->
 <template>
    <div>
        <!-- 按钮组 -->
        <div class="buttons_box">
            <el-button type="primary" size="mini" class="mini_button" style="margin-right: 5px;margin-top: 1px;" @click="ownerTransferSave">保存</el-button>
            <el-dropdown trigger="click" @command="(command) => report(command)">
                <span class="el-dropdown-link">
                    <el-button type="primary" size="mini" class="mini_button" >打印</el-button>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="存货卡_有标识_保税">存货卡_有标识_保税</el-dropdown-item>
                    <el-dropdown-item command="存货卡_有标识_非保税">存货卡_有标识_非保税</el-dropdown-item>
                    <el-dropdown-item command="存货卡_无标识_保税">存货卡_无标识_保税</el-dropdown-item>
                    <el-dropdown-item command="存货卡_无标识_非保税">存货卡_无标识_非保税</el-dropdown-item>
                    <el-dropdown-item command="存货卡_建发">存货卡_建发</el-dropdown-item>
                    <el-dropdown-item command="入库单">入库单</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-button type="primary" size="mini" class="mini_button">完成</el-button>
            <el-button type="primary" size="mini" class="mini_button">车辆报备</el-button> -->
        </div>
        <!-- 表头 -->
        <el-form class="demo-form-inline ownerTransferForm" :inline="true" ref="ownerTransferForm" :model="ownerTransferForm" 
        :rules="ownerTransferFormRules" size="mini" label-width="160px">
            <el-divider content-position="left">任务信息</el-divider>
            <el-form-item label="货转单号" prop="billNo"> 
                <el-input disabled v-model="ownerTransferForm.billNo" suffix-icon="xxxx" ></el-input>
            </el-form-item>
            <el-form-item label="货转状态" prop="status"> 
                <el-input disabled placeholder="" v-model="ownerTransferForm.status"  suffix-icon="xxxx"></el-input>
            </el-form-item>
            <el-form-item label="单证员" prop="operator"> 
                <el-input disabled v-model="ownerTransferForm.operator"  suffix-icon="xxxx" ></el-input>
            </el-form-item> 
            <el-form-item label="创建日期" prop="createDate"> 
                <el-date-picker disabled v-model="ownerTransferForm.createDate" type="date" value-format="yyyy-MM-dd"  placeholder="" style="width:100%"> </el-date-picker>
            </el-form-item>
            <el-form-item label="仓库" prop="ckName">
                <el-select :disabled="!!ownerTransferPlanData.length" placeholder="请选择仓库" v-model="ownerTransferForm.ckName" clearable>
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="货主单位" prop="ownerName">
                <el-select :disabled="!!ownerTransferPlanData.length" filterable placeholder="请选择货主单位" v-model="ownerTransferForm.ownerName">
                    <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="新货主单位" prop="newOwnerName">
                 <el-select :disabled="!!ownerTransferPlanData.length" filterable placeholder="请选择货主单位" v-model="ownerTransferForm.newOwnerName">
                    <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提单号" prop="blNo">
                <el-input disabled v-model="ownerTransferForm.blNo"  suffix-icon="xxxx" ></el-input>
            </el-form-item>
            <el-form-item label="件数1" prop="totalQty1">
                <el-input disabled v-model="ownerTransferForm.totalQty1"  suffix-icon="xxxx" ></el-input>
            </el-form-item>
            <el-form-item label="净重" prop="totalNetWeight">
                <el-input disabled v-model="ownerTransferForm.totalNetWeight"  suffix-icon="xxxx" ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="note"> 
                <el-input placeholder="请输入备注" v-model="ownerTransferForm.note" suffix-icon="xxxx" style="width: 550px;"></el-input>
            </el-form-item>
        </el-form>
         <div class="label_box" >
                <div class="label">
                    上传附件
                </div>
                <div>
                    <el-upload class="upload-demo" :action="upLoadFilesURL" :file-list="fileList" :auto-upload="false"
                    :on-change="handleChange" :on-remove="handleRemove" multiple   :accept="acceptTypes" >
                    <el-button slot="trigger" size="small" type="primary" plain style="margin-right: 10px;">选择文件</el-button>
                    </el-upload>
                    <div>
                        <span v-for="item in otFileList" :key="item.id">
                            <el-link type="primary" class="list-margin" @click="previewFile(item)">{{ item.fileName }}</el-link>
                        </span>
                    </div>
                </div>
            </div>
        <el-divider content-position="left">计划信息</el-divider>
        <div class="buttons_box" style="justify-content: space-between;">
            <div>
            </div>
            <vxe-toolbar ref="toolbarRef"  custom ></vxe-toolbar>
        </div>
        <vxe-table id="inventoryMoveTable"  size="mini" ref="inventoryMoveTable" :data="ownerTransferPlanData" border stripe
            :custom-config="ownerTransferPlanCustomConfig"  header-align="center"  :columns="inventoryMovePlanColumns"
            :column-config="{resizable: true,sortable: true,drag:true}" max-height="250"
            :row-config="{ isHover: true}" :radio-config="{labelField: '', highlight: true}">
            <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column v-for="column in inventoryMovePlanColumns" :field="column.field" :title="column.title" sortable >
                     <template #default="{ row, column }">
                        <!-- <span v-if="column.field === 'decCurrency'"> 
                            {{ row.decCurrencyName }}
                        </span>
                        <span v-else-if="column.field === 'originCountry'"> 
                            {{ row.originCountryName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitFirst'"> 
                            {{ row.lawUnitFirstName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitSecond'"> 
                            {{ row. lawUnitSecondName }}
                        </span>
                        <span v-else-if="column.field === 'decUnit'"> 
                            {{ row. decUnitName }}
                        </span> -->
                        <!-- <span v-else> {{ row[column.field] }} </span> -->
                        <span > {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
                 <vxe-column title="操作" width="80" align="center" fixed="right" >
                    <template #default="{ row }">
                        <el-button type="text" size="mini" class="mini_button" @click="deleteInventoryPlan(row)"
                        :disabled="ownerTransferForm.status !== '新建' ">删除</el-button>
                    </template>
                </vxe-column>
        </vxe-table>
        <el-divider content-position="left" >库存信息</el-divider>
        <el-form class="demo-form-inline" :inline="true" ref="ownerTransferSeachForm" :model="ownerTransferSeachForm" size="mini" label-width="80px"
        :rules="ownerTransferSeachFormRules">
            <el-form-item label="货物名称" prop="goodsName"> 
                <el-select class="width_100" filterable :default-first-option="true" remote :remote-method="getGoodsList"
                    placeholder="请选择货物名称" v-model="ownerTransferSeachForm.goodsName" clearable>
                    <el-option v-for="item in goodsList" :key="item.id" :label="item.goodsName" :value="item.goodsName">
                        <span class="margin_right_20">{{ item.goodsName }}</span>
                        <span class="margin_right_20">{{ item.goodsType }}</span> 
                        <span >{{ item.hsCode }}</span> 
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="货主" prop="ownerName"> 
                <el-select disabled filterable placeholder="请选择货主" v-model="ownerTransferSeachForm.ownerName" clearable>
                    <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提单号" prop="blNo"> 
                <el-input placeholder="请输入提单号" v-model="ownerTransferSeachForm.blNo" clearable ></el-input>
            </el-form-item>
            <el-form-item label="仓库" prop="ckName"> 
                <el-select disabled clearable placeholder="请选择仓库" v-model="ownerTransferSeachForm.ckName">
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item" > </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="库区" prop="place"> 
                <el-select class="width_100" @change="placeEnter" v-model="ownerTransferSeachForm.place" placeholder="请选择库区" clearable>
                    <el-option v-for="item in placeList"  :key="item.name" :label="item.name " :value="item.name + '-' + item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="库位" prop="location">
                <el-select class="width_100" filterable v-model="ownerTransferSeachForm.location" placeholder="请选择库位" clearable>
                    <el-option v-for="item in locationList"  :key="item.locationName" :label="item.locationName " :value="item.locationName">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" prop=""> 
                <el-button type="primary" size="mini" @click="ownerTransferSeach">搜索</el-button>
            </el-form-item>
        </el-form>
        <vxe-table id="inventoryTable" size="mini" ref="inventoryTable" :data="inventoryList" border stripe max-height="250"
            :column-config="{resizable: true,sortable: true}" header-align="center" :row-config="{ isHover: true}" 
            :radio-config="{labelField: '', highlight: true}" >
            <vxe-column type="seq" width="50" fixed="left"></vxe-column>
            <vxe-column field="blNo" title="提单号" width="100" fixed="left"></vxe-column>
            <vxe-column field="goodsName" title="货物名称" width="180" fixed="left"></vxe-column>
            <vxe-column field="ownerName" title="货主单位" width="180" fixed="left"></vxe-column>
            <vxe-column field="customer" title="委托单位" width="180"></vxe-column>
            <vxe-column field="goodsType" title="货物分类" width="100"></vxe-column>
            <vxe-column field="isBonded" title="保税类型" width="70"></vxe-column>
            <vxe-column field="spec" title="规格型号" min-width="150"></vxe-column>
            <vxe-column field="hsCode" title="海关编码" width="100"></vxe-column>
            <vxe-column field="invDecNo" title="核注清单号" width="140"></vxe-column>
            <vxe-column field="cusDeclNo" title="报关单号" width="140"></vxe-column>
            <vxe-column field="skuNo" title="商品料号" width="130"></vxe-column>
            <vxe-column field="handbook" title="账册编号" width="110"></vxe-column>
            <vxe-column field="createDate" title="入库日期" width="100"></vxe-column>
            <vxe-column field="ckName" title="仓库" width="100"></vxe-column>
            <vxe-column field="place" title="库区" width="100"></vxe-column>
            <vxe-column field="location" title="库位" width="100"></vxe-column>
            <vxe-column field="totalNetWeight" title="净重" width="100"></vxe-column>
            <vxe-column field="decUnitName" title="申报单位" width="100"></vxe-column>
            <vxe-column field="totalDecNum" title="申报数量" width="100"></vxe-column>
            <vxe-column field="totalQty1" title="件数1" width="100"></vxe-column>
            <vxe-column field="qty1UnitName" title="件数1单位" width="100"></vxe-column>
            <vxe-column field="totalQty2" title="件数2" width="100"></vxe-column>
            <vxe-column field="qty2UnitName" title="件数2单位" width="100"></vxe-column>
            <vxe-column field="lawUnitFirstName" title="法定第一单位" width="100"></vxe-column>
            <vxe-column field="totalFirstNum" title="法定第一数量" width="100"></vxe-column>
            <vxe-column field="lawUnitSecond" title="法定第二单位" width="100"></vxe-column>
            <vxe-column field="totalSecondNum" title="法定第二数量" width="100"></vxe-column>
            <vxe-column field="note" title="备注" width="100"></vxe-column>
            <!-- 操作列 -->
             <vxe-column title="操作" width="70" fixed="right">
                <template v-slot="scope"> 
                    <el-button type="primary" size="mini" @click="AddOwnerTransferPlan(scope.row)"
                    :disabled="ownerTransferForm.status !== '新建' ">货转</el-button>
                </template>
             </vxe-column>
        </vxe-table>
        <div style="width: 100%;height: 200px;"></div>
        <!-- 添加移库计划弹出框 -->
        <el-dialog title="货转计划信息" width="75%" :visible.sync="ownerTransferVisible" :before-close="ownerTransferClose" v-dialogDrag
            :close-on-click-modal="false">
            <el-descriptions title="" :column="4" size="medium">
                <el-descriptions-item label="保税类型">{{ ownerTransferPlanRows.isBonded }}</el-descriptions-item>
                <el-descriptions-item label="货物名称">{{ ownerTransferPlanRows.goodsName }}</el-descriptions-item>
                <el-descriptions-item :span="2" label="规格型号">{{ ownerTransferPlanRows.spec }}</el-descriptions-item>
                <el-descriptions-item label="货主单位">{{ ownerTransferPlanRows.ownerName }}</el-descriptions-item>
                <el-descriptions-item label="提单号">{{ ownerTransferPlanRows.blNo }}</el-descriptions-item>
                <el-descriptions-item label="报关单号">{{ ownerTransferPlanRows.cusDeclNo }}</el-descriptions-item>
                <el-descriptions-item label="核注清单号">{{ ownerTransferPlanRows.invDecNo }}</el-descriptions-item>
                <el-descriptions-item label="仓库">{{ ownerTransferPlanRows.ckName }} - {{ ownerTransferPlanRows.place }} - {{ ownerTransferPlanRows.location }}</el-descriptions-item>
                <el-descriptions-item label="净重(KG)">{{ ownerTransferPlanRows.totalNetWeight }}</el-descriptions-item>
                <el-descriptions-item label="申报数量">{{ ownerTransferPlanRows.totalDecNum }} {{ ownerTransferPlanRows.decUnitName }}</el-descriptions-item>
                <el-descriptions-item label="申报金额">{{ ownerTransferPlanRows.totalDecAmount }} {{ ownerTransferPlanRows.decCurrency }}</el-descriptions-item>
                <el-descriptions-item label="件数1">{{ ownerTransferPlanRows.totalQty1 }} {{ ownerTransferPlanRows.qty1UnitName }}</el-descriptions-item>
                <el-descriptions-item label="件数2">{{ ownerTransferPlanRows.totalQty2 }} {{ ownerTransferPlanRows.qty2UnitName }}</el-descriptions-item>
                <el-descriptions-item label="法定第一数量">{{ ownerTransferPlanRows.totalFirstNum }} {{ ownerTransferPlanRows.lawUnitFirstName }}</el-descriptions-item>
                <el-descriptions-item label="法定第二数量">{{ ownerTransferPlanRows.totalSecondNum }} {{ ownerTransferPlanRows.lawUnitSecondName }}</el-descriptions-item>
            </el-descriptions>
             <el-form class="demo-form-inline" :inline="true" ref="ownerTransferAddForm" :model="ownerTransferAddForm" size="mini" label-width="120px"
            :rules="inventoryMoveAddRules">
                <el-form-item label="件数1" prop="qty1"> 
                    <el-input  v-model="ownerTransferAddForm.qty1"  suffix-icon="xxxx" @blur="qty1Blur"></el-input>
                </el-form-item>
                <el-form-item label="件数2" :prop="ownerTransferPlanRows.totalQty2? 'qty2':''" > 
                    <el-input :disabled="!ownerTransferPlanRows.totalQty2" v-model="ownerTransferAddForm.qty2"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="净重(KG)" prop="netWeight"> 
                    <el-input v-model="ownerTransferAddForm.netWeight"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="申报数量" :prop="ownerTransferPlanRows.totalDecNum? 'decNum':''" > 
                    <el-input :disabled="!ownerTransferPlanRows.totalDecNum" v-model="ownerTransferAddForm.decNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="法定第一数量" :prop="ownerTransferPlanRows.totalFirstNum? 'firstNum':''"> 
                    <el-input :disabled="!ownerTransferPlanRows.totalFirstNum" v-model="ownerTransferAddForm.firstNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="法定第二数量" :prop="ownerTransferPlanRows.totalSecondNum? 'secondNum':''" > 
                    <el-input :disabled="!ownerTransferPlanRows.totalSecondNum" v-model="ownerTransferAddForm.secondNum"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="申报金额" :prop="ownerTransferPlanRows.totalDecAmount? 'decAmount':''"> 
                    <el-input :disabled="!ownerTransferPlanRows.totalDecAmount" v-model="ownerTransferAddForm.decAmount"  suffix-icon="xxxx"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="saveAddOwnerTransferPlan">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'
import AEObasicData from '@/config/AEObasicData.js'
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate, webapp_ws_ajax_together } from "../../utils/reports/grwebapp";
export default {
    name: 'ownerTransfer',
    mixins: [userProfile],
    components:{

    },
    watch: { 
        // 根据仓库不同切换不同的理货员
        'ownerTransferForm.ckName':{
            handler(newVal, oldVal) {
                if (newVal === '纽约路仓库') {
                    // 根据仓库名称切换理货员
                    this.storekeeperList = basicData.storekeeperList ;
                }else if (newVal === '七星河路仓库'){
                    this.storekeeperList = basicData.storekeeperListOut ;
                }else{
                    this.storekeeperList = []
                }
            },
            immediate: true, // 是否立即执行一次
            deep: false // 是否深度监听
        },
    },
    data() {
        // 自定义验证函数  件数1移库计划
        const validateQty1 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数1")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.ownerTransferPlanRows.totalQty1) {
                return callback(new Error(`件数1不能超过 ${this.ownerTransferPlanRows.totalQty1}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  件数2出库计划
        const validateQty2 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数2")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.ownerTransferPlanRows.totalQty2) {
                return callback(new Error(`件数2不能超过 ${this.ownerTransferPlanRows.totalQty2}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  净重出库计划
        const validateNetWeight = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入净重")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.ownerTransferPlanRows.totalNetWeight) {
                return callback(new Error(`净重不能超过 ${this.ownerTransferPlanRows.totalNetWeight}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  申报数量出库计划
        const validateDecNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.ownerTransferPlanRows.totalDecNum) {
                return callback(new Error(`申报数量不能超过 ${this.ownerTransferPlanRows.totalDecNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  法1出库计划
        const validateFirstNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第一数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.ownerTransferPlanRows.totalFirstNum) {
                return callback(new Error(`法定第一数量不能超过 ${this.ownerTransferPlanRows.totalFirstNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  法2出库计划
        const validateSecondNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第二数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.ownerTransferPlanRows.totalSecondNum) {
                return callback(new Error(`法定第二数量不能超过 ${this.ownerTransferPlanRows.totalSecondNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数  申报金额出库计划
        const validateDecAmount = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报金额")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (parseFloat(value) > this.ownerTransferPlanRows.totalDecAmount) {
                return callback(new Error(`申报金额不能超过 ${this.ownerTransferPlanRows.totalDecAmount}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        return{
            ownerTransferPlanCustomConfig:null, // 自定义表格配置
            hasHandledToken:false,
            customerList:[], // 货主列表
            goodsList:[], // 货物名称列表
            ckNameList:[], // 获取仓库列表
            placeList:[], // 库区列表
            locationList:[], // 库位列表
            inventoryList:[], // 库存列表
            storekeeperList:[], // 理货员列表
            ownerTransferVisible:false, // 移库弹窗
            unitList:AEObasicData.CUS_UNIT, // 计量单位
            ownerTransferForm:{
                operator:'', // 创建人
                opType:'移库',
                note:'',
                billNo:'',
                status:'',
                createDate:'',
                ownerName:'',
                ckName:'',
                blNo:'',
                goodsName:''
            },
            ownerTransferFormRules:{
                ownerName: [
                    { required: true, message: '请选择货主', trigger: 'change' }
                ],
                ckName: [
                    { required: true, message: '请选择仓库', trigger: 'change' }
                ],
                newOwnerName: [
                    { required: true, message: '请选择新货主', trigger: 'change' }
                ],
            },
            ownerTransferPlanData:[], // 货转计划列表
            ownerTransferPlanRows:{}, // 库存选中行
            placeAddList:[], // 添加移库中的库区列表
            locationAddList:[], // 添加移库中的库位列表
            ownerTransferSeachForm:{ // 查询库存表单
                goodsName:'',
                ownerName:'',
                blNo:'',
                ckName:'',
                place:'',
                location:'',
            },
            ownerTransferSeachFormRules:{
                // goodsName:[
                //     { required: true, message: '请选择货物名称', trigger: 'blur' },
                // ],
            }, // 搜索库存表单规则
            ownerTransferAddForm:{ // 添加货转弹窗中表单
                newckName:'',
                newPlace:'', 
                newLocation:'',
            },
            // 添加移库表单规则
            inventoryMoveAddRules:{
                qty1:[
                    { required: true, message: '请输入件数1', trigger: 'blur' },
                    { validator: validateQty1, trigger: "blur" }
                ],
                qty2:[
                    { required: true, message: '请输入件数2', trigger: 'blur' },
                    { validator: validateQty2, trigger: "blur" }
                ],
                netWeight:[
                    { required: true, message: '请输入净重', trigger: 'blur' },
                    { validator: validateNetWeight, trigger: "blur" }
                ],
                decNum:[
                    { required: true, message: '请输入申报数量', trigger: 'blur' },
                    { validator: validateDecNum, trigger: "blur" }
                ],
                firstNum:[
                    { required: true, message: '请输入法定第一数量', trigger: 'blur' },
                    { validator: validateFirstNum, trigger: "blur" }
                ],
                secondNum:[
                    { required: true, message: '请输入法定第二数量', trigger: 'blur' },
                    { validator: validateSecondNum, trigger: "blur" }
                ],
                decAmount:[
                    { required: true, message: '请输入申报金额', trigger: 'blur' },
                    { validator: validateDecAmount, trigger: "blur" }
                ],
            },
            //实际使用的列配置（从本地存储恢复或用默认）
            inventoryMovePlanColumns:[],
            fileList:[],
            otFileList:[], // 已上传
            upLoadFilesURL:'wms/taskOp/upLoadFiles',
            acceptTypes: '.jpg,.jpeg,.png,.pdf,.JPG,.JPEG,.PNG,.PDF',
            // 允许的文件扩展名
            allowedExtensions: ['.jpg', '.jpeg', '.png','.pdf']
        }
    },
    created() {
        window.addEventListener('message', (event) => {
            if (event.source === window) {
                // 当页面消息来自自己时（F5刷新）并且hasHandledToken为false时（证明是第一次执行，保证接口只调用一次）
                if(localStorage.getItem('id') && !this.hasHandledToken){
                    this.ownerTransferPlanCustomConfig = this.customConfig
                    this.getCustomerList()
                    this.getckNameList()
                    // 查询详情
                    this.getWMSOwnerDetail(localStorage.getItem('id'))
                }
                return false
            }
            // 父页面消息
            this.handleMessage(event);
        });
    },
    mounted() {
        // 获取当前日期
         this.ownerTransferForm.createDate = new Date().toISOString().split('T')[0] // 格式化为 "2026-02-03"
         window.addEventListener('beforeunload', this.notifyParentBeforeUnload);
    },
    methods: {
        // 接收父窗口的消息
        handleMessage(event) {
            if (event.data.type === 'SET_TOKEN' && !this.hasHandledToken) {
                this.hasHandledToken = true;
                localStorage.setItem('token', event.data.token);
                localStorage.setItem('name', event.data.name);
                localStorage.setItem('parentOrigin', event.data.parentOrigin);
                // 向父窗口发送消息
                event.source.postMessage(
                    { type: 'TOKEN_RECEIVED' },
                    event.origin
                );
                Promise.resolve().then(() => {
                    this.ownerTransferPlanCustomConfig = this.customConfig
                    this.getckNameList()
                    this.getCustomerList()
                    if(event.data.id !== ''){
                        localStorage.setItem('id', event.data.id);
                        this.getWMSOwnerDetail(localStorage.getItem('id'))
                        
                    }else{
                        this.ownerTransferForm.operator = event.data.name
                    }
                })
            }
        },
        // 获取货主列表
        getCustomerList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 获取货物计划列表
        getGoodsList(value){
            this.$api.getInUseListBy({param:value} ).then(res =>{
            // this.$api.wmsgetListBy( 1,100,{param:value} ).then(res =>{
                this.goodsList = res.tableData
            })
        }, 
        // 获取仓库
        getckNameList(){
            this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
            })
        },
        // 获取库区列表
        getStore(){
            this.$api.getStore( this.ownerTransferSeachForm.ckName ).then(res =>{
                this.placeList = res
            })
        },
        // 查询库位列表
        getLocation(id){
            this.$api.getLocation( id ).then(res =>{
                this.locationList = res
            })
        },
        // // 上传前检查上传文件格式
        // beforeUpload(file){
        //     const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
        //     // 验证文件类型
        //     if (!this.allowedExtensions.includes(fileExtension)) {
        //         this.$message.error(`文件 ${file.name} 格式不支持！只能上传图片和PDF文件`)
        //         return false
        //     }
        //     //   // 验证文件大小（10MB限制）
        //     //   const isLt10M = file.size / 1024 / 1024 < 10
        //     //   if (!isLt10M) {
        //     //     this.$message.error('文件大小不能超过10MB！')
        //     //     return false
        //     //   }
      
        //     return true
        // },
        // 保存表头
        async ownerTransferSave(){
            // 判断是否上传附件
            if(this.fileList.length === 0 && this.otFileList.length === 0){
                this.$message.error('请上传附件')
                return false
            }
            // 如果有id则新增，有则修改
            if(this.ownerTransferForm.billNo && this.ownerTransferForm.billNo !== '' ){
                // await this.$api.wmsGetOtHeadById( this.ownerTransferForm.id )
                await this.$api.wmsUpdateOtHead( this.ownerTransferForm )
                this.$message.success('保存成功');
                await this.getWMSOwnerDetail(this.ownerTransferForm.id)
            } else{
                // 必填验证
                this.$refs.ownerTransferForm.validate(async (valid) => {
                    if (valid) {
                        const res = await this.$api.wmsInsertOtHead( this.ownerTransferForm )
                        if (localStorage.getItem('id')) {
                            localStorage.setItem('id', res);
                        }
                        await this.getWMSOwnerDetail(res);
                        // 等待查询详情完成
                        this.$message.success('保存成功');
                    }
                })
            }
            // 上传附件
            if (this.fileList.length > 0) {
                let hasInvalidFile = false
                for (let i = 0; i < this.fileList.length; i++) {
                    const file = this.fileList[i]
                    const fileName = file.name || file.raw?.name || ''
                    const fileExtension = '.' + fileName.split('.').pop().toLowerCase()

                    if (!this.allowedExtensions.includes(fileExtension)) {
                        this.$message.error(`文件 ${fileName} 格式不支持！只能上传图片和PDF文件`)
                        hasInvalidFile = true
                        break
                    }
                }
                if (hasInvalidFile) {
                    return false
                }
                const formData = new FormData();
                this.fileList.forEach(item => {
                    formData.append('files', item.raw);
                });
                await this.$api.wmsupLoadFilesIMG('货转', this.ownerTransferForm.id, formData )
            }
            // 查询上传附件
            await this.wmsGetTaskFiles()
            this.fileList = []
        },
        // 查询上传文件
        wmsGetTaskFiles(){
            this.$api.wmsGetTaskFiles(this.ownerTransferForm.id).then(res => {
                this.otFileList = res.otFiles
            })
        },
        // 查询货转任务单详情
        getWMSOwnerDetail(id){
            this.$api.wmsGetOtHeadById( id ).then(res =>{
                this.ownerTransferForm = res.otMain
                this.inventoryMovePlanColumns = res.otSub.columns
                this.ownerTransferPlanData = res.otSub.tableData
                // 赋值搜索库存的货主和仓库
                this.ownerTransferSeachForm.ownerName = res.otMain.ownerName
                this.ownerTransferSeachForm.ckName = res.otMain.ckName
                // 更新表头
                this.wmsUpdateOtHead()
                // 查询库区
                this.getStore()
                this.wmsGetTaskFiles()
            })
        },
        // 查询库存
        ownerTransferSeach(){
            // 检查是否保存表头
            if(this.ownerTransferForm.billNo === '' ){
                this.$message.error('请先保存表头');
                return false
            }
            this.$refs.ownerTransferSeachForm.validate(async (valid) => {
                if (valid) {
                    this.$api.wmsGetStockList( this.ownerTransferSeachForm ,1000,1).then(res =>{
                        this.inventoryList = res.records
                    })
                }
            })
        },
        // 根据库区查询库位列表
        placeEnter(value){
            if(value === ''){
                this.ownerTransferSeachForm.place = ''
                this.locationList = []
            }else{
                const item  = value.split('-')
                this.ownerTransferSeachForm.place = item[0]
                this.getLocation(item[1])
            }
            this.ownerTransferSeachForm.location = ''
        },
        // 添加移库计划
        AddOwnerTransferPlan(row){
            this.ownerTransferPlanRows = row
            // 搜索当前仓库下库区
            this.$api.getStore( this.ownerTransferPlanRows.ckName ).then(res =>{
                this.placeAddList = res
                // 数量赋值
                this.ownerTransferAddForm = {
                    newckName:this.ownerTransferPlanRows.ckName,
                    newPlace:'',
                    newLocation: '',
                    qty1: this.ownerTransferPlanRows.totalQty1,
                    qty2:   this.ownerTransferPlanRows.totalQty2,
                    netWeight:  this.ownerTransferPlanRows.totalNetWeight,
                    decNum: this.ownerTransferPlanRows.totalDecNum,
                    decAmount:  this.ownerTransferPlanRows.totalDecAmount,
                    firstNum: this.ownerTransferPlanRows.totalFirstNum,
                    secondNum: this.ownerTransferPlanRows.totalSecondNum,
                }
                this.ownerTransferVisible = true
            })
        },
        // 关闭添加货转弹窗
        ownerTransferClose(){
            this.ownerTransferVisible = false
        },
        // 当添加货转计划中的件数1发生改变时，同时改件数2，净重，申报数量，金额
        qty1Blur(){
            // 净重
            this.ownerTransferAddForm.netWeight = this.calculateAllPlanFields(this.ownerTransferPlanRows.totalNetWeight,this.ownerTransferPlanRows.totalQty1,this.ownerTransferAddForm.qty1)
            this.ownerTransferAddForm.qty2 = this.calculateAllPlanFields(this.ownerTransferPlanRows.totalQty2,this.ownerTransferPlanRows.totalQty1,this.ownerTransferAddForm.qty1)
            this.ownerTransferAddForm.decNum = this.calculateAllPlanFields(this.ownerTransferPlanRows.totalDecNum,this.ownerTransferPlanRows.totalQty1,this.ownerTransferAddForm.qty1)
            this.ownerTransferAddForm.decAmount = this.calculateAllPlanFields(this.ownerTransferPlanRows.totalDecAmount,this.ownerTransferPlanRows.totalQty1,this.ownerTransferAddForm.qty1)
            this.ownerTransferAddForm.firstNum = this.calculateAllPlanFields(this.ownerTransferPlanRows.totalFirstNum,this.ownerTransferPlanRows.totalQty1,this.ownerTransferAddForm.qty1)
            this.ownerTransferAddForm.secondNum = this.calculateAllPlanFields(this.ownerTransferPlanRows.totalSecondNum,this.ownerTransferPlanRows.totalQty1,this.ownerTransferAddForm.qty1)
        },  
        // 净重、申报数量、金额、件数2，法一，法二 计算
        calculateAllPlanFields(number,qty1All,qty1Actual){
            if(!number){
                return null
            }else{
                const value = Number(number) || 0;
                const qty1 = Number(qty1All); // 选中数据的件数1
                const planQty1 = Number(qty1Actual); // 填写出库的件数1
                // 计算并保留指定位小数
                const result = (value / qty1) * planQty1;
                const factor = Math.pow(10, 4);  // 10000
                // Number.EPSILON  大约是 2.220446049250313e-16 这是 JavaScript 中最小的正数用于解决浮点数计算中的精度问题
                return Math.round((result + Number.EPSILON) * factor) / factor;  // 加一个极小的数，避免浮点数误差;乘以10^4，将小数变为整数,四舍五入
            }
        },
        // 添加货转计划
        async saveAddOwnerTransferPlan(){
            try {
                const valid = await new Promise((resolve) => {
                    this.$refs.ownerTransferAddForm.validate((valid) => {
                        resolve(valid);
                    });
                });
                if (!valid) {
                    this.$message.error('请填写必填字段');
                    return false;
                }
                    var headId = this.ownerTransferForm.id
                // 保存表体
                const params = {
                    taskType:'货转',
                    rowStatus: '', // 状态   
                    blNo: this.ownerTransferPlanRows.blNo, // 提单号
                    interId:headId, // 父id,表头id
                    goodsType: this.ownerTransferPlanRows.goodsType, // 货物类型
                    hsCode: this.ownerTransferPlanRows.hsCode, // 海关编码
                    goodsName: this.ownerTransferPlanRows.goodsName, // 货物名称
                    spec: this.ownerTransferPlanRows.spec, // 规格型号
                    ownerName: this.ownerTransferPlanRows.ownerName, // 货主
                    ckName: this.ownerTransferPlanRows.ckName, // 仓库
                    place: this.ownerTransferPlanRows.place, // 库区
                    location: this.ownerTransferPlanRows.location, // 库位
                    qty1Unit: this.ownerTransferPlanRows.qty1Unit, // 件数1单位
                    qty2Unit: this.ownerTransferPlanRows.qty2Unit, // 件数2单位
                    // packageType:this.inventorySelected.packageType, // 包装   库存没包装
                    decUnit: this.ownerTransferPlanRows.decUnit, // 申报单位代码
                    decUnitName: this.ownerTransferPlanRows.decUnitName,
                    decCurrency: this.ownerTransferPlanRows.decCurrency, // 币制
                    stockDate:this.ownerTransferPlanRows.createDate ,// 入库日期
                    originCountry:this.ownerTransferPlanRows.originCountry, // 原产地 库存没有原产地
                    lawUnitFirst: this.ownerTransferPlanRows.lawUnitFirst, // 法一单位
                    lawUnitFirstName: this.ownerTransferPlanRows.lawUnitFirstName,
                    lawUnitSecond: this.ownerTransferPlanRows.lawUnitSecond, // 法二单位
                    itemNo:this.ownerTransferPlanRows.itemNo, // 项号
                    skuNo: this.ownerTransferPlanRows.skuNo, // 商品料号
                    decPrice:this.ownerTransferPlanRows.decPrice, // 单价
                    isBonded:this.ownerTransferPlanRows.isBonded, // 保税
                    handbook:this.ownerTransferPlanRows.handbook, // 账册号
                    cusDeclNo:this.ownerTransferPlanRows.cusDeclNo, 
                    invDecNo:this.ownerTransferPlanRows.invDecNo,
                    boxNo:this.ownerTransferPlanRows.boxNo,
                    customer: this.ownerTransferPlanRows.customer,   
                    stockDateNum: this.ownerTransferPlanRows.stockDateNum,
                    lotNo:this.ownerTransferPlanRows.lotNo,
                    lotOrderNo:this.ownerTransferPlanRows.lotOrderNo,
                    lotMaterialNo:this.ownerTransferPlanRows.lotMaterialNo,
                    originCountryName:this.ownerTransferPlanRows.originCountryName,
                    newCkName:this.ownerTransferPlanRows.ckName,
                    newPlace:this.ownerTransferPlanRows.place,
                    newLocation:this.ownerTransferPlanRows.location,

                    qty1: this.ownerTransferAddForm.qty1,
                    qty2: this.ownerTransferAddForm.qty2 ? this.ownerTransferAddForm.qty2 : null,
                    decAmount: this.ownerTransferAddForm.decAmount, // 总价（申报金额）
                    netWeight: this.ownerTransferAddForm.netWeight, // 净重
                    decNum: this.ownerTransferAddForm.decNum, // 申报数量
                    firstNum: this.ownerTransferAddForm.firstNum ? this.ownerTransferAddForm.firstNum : null, // 法一数
                    secondNum: this.ownerTransferAddForm.secondNum ? this.ownerTransferAddForm.secondNum : null, // 法二数
                    note:this.ownerTransferPlanRows.note,

                }
                //保存货转计划
                const redID = await this.$api.insOneRecordWMSTask(params);
                const paramsDetail = { ...params,subId : redID,taskNo : this.ownerTransferForm.billNo,createDate:this.ownerTransferPlanRows.createDate ,newOwnerName:this.ownerTransferForm.newOwnerName}
                // params.subId = redID
                // params.taskNo = this.ownerTransferForm.billNo
                await this.$api.wmsAddStockMoveDetail(paramsDetail);
                // 刷新页面
                await this.getWMSOwnerDetail(headId)
                // 刷新库存
                await this.ownerTransferSeach()
                // 关闭弹窗
                await this.ownerTransferClose();
            } catch (error) {
                this.$message.error('保存失败');
            }
        },
        // 删除货转计划
        async deleteInventoryPlan( row ){
            this.$confirm('是否删除此计划?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmsRemoveDetailById(row.id).then( async res =>{
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                    // 刷新页面
                    await this.getWMSOwnerDetail(this.ownerTransferForm.id)
                    // 刷新库存
                   await this.ownerTransferSeach()
                })
            })
        },
        // 更新表头
        wmsUpdateOtHead(){
            var newQty1 = 0
            var newBlNo = ''
            var newNetWeight = 0
            if(this.ownerTransferPlanData.length !== 0){
                // 保存情况下，更新表头信息，去重
                newQty1 =  this.ownerTransferPlanData.reduce((sum, item) => {
                    if (item && item.qty1 != null) {
                        const value = Number(item.qty1);
                        return sum + (isNaN(value) ? 0 : value);
                    }
                    return sum;
                }, 0);
                newBlNo =  [...new Set(
                    this.ownerTransferPlanData
                        .map(item => item?.blNo?.trim())  // 提取并清理 blNo
                        .filter(blNo => blNo != null && blNo !== '')  // 过滤空值
                )].join(', ');
                newNetWeight = this.ownerTransferPlanData.reduce((sum, item) => {
                    if (item && item.netWeight != null) {
                        const value = Number(item.netWeight);
                        return sum + (isNaN(value) ? 0 : value);
                    }
                    return sum;
                }, 0);
            }
            this.ownerTransferForm.totalQty1 = newQty1
            this.ownerTransferForm.blNo = newBlNo
            this.ownerTransferForm.totalNetWeight = newNetWeight
            this.$api.wmsUpdateOtHead( this.ownerTransferForm )
        },
        // 文件上传时勾子-
        handleChange(file, fileList){
            this.fileList = fileList
        },
        // 移除文件勾子
        handleRemove(file, fileList) {
            this.fileList = fileList
        },
        // 预览
        previewFile(item){
            const params = {
                path: '/preview',
                query: {
                    annexUrl: item.filePath,
                    annexName: item.fileName,
                    id:item.id
                }
            }
            var childWindow = window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
            var loop = setInterval(() => {
                if (childWindow.closed) {  // 检测子窗口是否关闭
                    clearInterval(loop); // 停止定时器
                    // 子窗口关闭后父页面刷新
                    // this.getTable()
                }
            }, 100);
        }, 
        // 通用查找方法
        findNameByCode(code, list) {
            if (!code) return '';
            const item = list.find(item => item.codeValue === code);
            return item ? item.codeName : code; // 找不到就返回原编码
        },
        // 打印
        report(command){
            // 根据不同的 command 执行不同的打印逻辑
            switch (command) {
                case '存货卡_有标识_保税':
                    this.printCard(1);
                    break;
                case '存货卡_有标识_非保税':
                    this.printCard(2);
                    break;
                case '存货卡_无标识_保税':
                    this.printCard(3);
                    break;
                case '存货卡_无标识_非保税':
                    this.printCard(4);
                    break;
                case '存货卡_建发':
                    this.printCard(0);
                    break;
                case '入库单':
                    this.printInbound();
                    break;
                default:
                    this.$message.warning('未知的打印类型');
            }
           
        },
        // 存货卡
        async printCard(logo){
            // 判断是否保税
            var reportURL = ''
            if(logo === 1){
                reportURL = '/grf/存货卡_有标识.grf'
            }else if(logo === 2){
                reportURL = '/grf/存货卡_非保有标识.grf'
            }else if(logo === 3){
                reportURL = '/grf/存货卡_无标识.grf'
            }else if(logo === 4){
                reportURL = '/grf/存货卡_非保无标识.grf'
            }else if(logo === 0){
                reportURL = '/grf/存货卡_建发.grf'
            }
            const reports = []
            // 1. 构造报表数组
            this.ownerTransferPlanData.forEach( item => {
                const singleData = {
                    master: [{
                        goodsName: item.goodsName,
                        spec: item.spec,
                        completeTime: item.createDate,
                        location: item.location,
                        place: item.place,
                        ckName: item.ckName,
                        ownerName: this.ownerTransferForm.newOwnerName,
                        invDecNo: item.invDecNo,
                        qty1: item.qty1,
                        qty1UnitName: this.findNameByCode(item.qty1Unit, this.unitList),
                        qty2:item.qty2 ? '/' + item.qty2 : '' ,
                        qty2UnitName: this.findNameByCode(item.qty2Unit, this.unitList),
                        blNo: item.blNo,
                        remark: this.ownerTransferForm.note ? this.ownerTransferForm.note :'',
                        boxNo:item.boxNo,
                        truckNo:item.truckNo,
                    }],
                };
                reports.push({
                    report: urlAddRandomNo(reportURL), // 模板路径或JSON
                    data: singleData // 对应的数据
                });
            });
            // 2. 主参数 args
            var args = {
                type: "preview", // 或 "print"
                FontEmbedding: true
            };
            // 3. 调用 together 方法
            webapp_ws_ajax_together(args, reports);
        },
        // 打印入库单
        printInbound(){
            if(this.ownerTransferPlanData.length){
                var tableTask = this.ownerTransferPlanData.map(item => {
                    return {
                        ...item,
                        qtyUnitName:this.findNameByCode(item.qty1Unit, this.unitList),
                        // completeTime:item.completeTime ? item.completeTime.split('T')[0] : '',
                        placeLocation:item.place + '-' + item.location,
                    }
                })
                var master = {
                    ownerName:this.ownerTransferForm.newOwnerName,
                    createUser:this.ownerTransferForm.operator,
                    ckAddress:this.ownerTransferForm.ckName === '纽约路仓库' ? '青岛保税港区纽约路2号' : '青岛市黄岛区富源工业园七星河路363号',
                    note:this.ownerTransferForm.note,
                }
                const params = { master:master,table:tableTask }
                var args = {
                    report: urlAddRandomNo("/grf/入库单.grf"),
                    data: params,
                    type: "preview",
                    FontEmbedding: true,  //指定嵌入字体数据
                };
                webapp_ws_ajax_run(args);
            }
        },
        // 通知父级页面
        notifyParentBeforeUnload(){
            const targetOrigin =  localStorage.getItem('parentOrigin')
            window.opener.postMessage(
                { 
                    type: 'WINDOW_CLOSED',
                    value: true,
                },
                targetOrigin
            );
            // localStorage.clear();
        },
        setupMessageListener() {
            // 监听父页面发送的消息
            window.addEventListener('message', (event) => {
                // 验证消息来源（可选，增加安全性）
                if (event.origin !== window.location.origin) {
                // 如果不是同源消息，可以忽略或处理
                }
                if (event.data.type === 'CLOSE_WINDOW_FROM_PARENT') {
                    window.close();
                }
            });
        },
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.notifyParentBeforeUnload)
        
    },
}
</script>
<style style lang="less" scoped>
.width_100{
    width:100%;
}
// 按钮
.buttons_box{
    margin: 5px 15px;
    display: flex;
    align-items: center;
}
.mini_button{
    padding: 3px 8px !important;
}
.ownerTransferForm{
    margin: 10px;
}
// 表头样式
.ownerTransferForm .el-col-4{
    padding-left: 8px !important;
    padding-right: 8px !important;
}
.ownerTransferForm .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    // margin-bottom: 3px !important;
    margin-right: 5px !important;
}
// 分割线颜色
.el-divider__text{
    color: #797c81 !important;
}
.el-divider--horizontal {
    margin: 10px 0;
}
.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 5px;
}
.mini_button_text{
    padding: 3px 3px !important;

}
// 上传附件
.label_box{
    color: #606266;
    font-size: 14px;
    line-height: 28px;
    display: flex;
    margin: 0px 30px  10px 100px; 
}
.label{
    margin-right: 10px;
}
.list-margin{
    margin-right: 10px;
}
</style>